import { render } from "./FakeButton.vue?vue&type=template&id=309d4b36&scoped=true"
import script from "./FakeButton.vue?vue&type=script&lang=js"
export * from "./FakeButton.vue?vue&type=script&lang=js"

import "./FakeButton.vue?vue&type=style&index=0&id=309d4b36&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-309d4b36"

export default script